module.exports = __webpack_public_path__ + "static/icon-jike.e64717e0.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/icon-jike.png
// module id = 312
// module chunks = 2